<div class="card result-card card-hover border rounded-4">
  <ng-content select="[header]"></ng-content>
  <div class="card-body d-flex flex-column">
    <ng-content></ng-content>
  </div>
  <div class="fs-8 card-footer bg-transparent border-0 pb-3 pt-0">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
